module.exports = __webpack_public_path__ + "img/BYD.cbdb845a.webp";